// extracted by mini-css-extract-plugin
module.exports = {"header_update":"Nav_header_update__25iSr","dark":"Nav_dark__1oel9","header_nav_reset":"Nav_header_nav_reset__3-kV6"};